// Utils
import { apiFetch } from '../utils/api';
import { isFirstRender } from '../utils/data';
import { logToConsole } from '../utils/log';


const API = Object.freeze({
  LOGGER: {
    AUDIT: 'api/logger/audit'
  }
});


class Logger {
  static layerOnReportBuilder(profile, mapLayer) {
    const { name, projectName, categoryName } = mapLayer;
    const {
      primaryZip, userName, firstName, lastName, primaryOrganization,
      primaryOrganizationType, primaryTitle, title, primaryZipLatitude,
      primaryZipLongitude, primaryReferer
    } = profile.data;
    const layerOn = {
      layerName: name,
      projectName: projectName,
      categoryName: categoryName,
      postalCode: primaryZip,
      userName: userName,
      firstName: firstName,
      lastName: lastName,
      organization: primaryOrganization,
      organizationType: primaryOrganizationType,
      title: primaryTitle,
      role: title,
      primaryZipLatitude: primaryZipLatitude,
      primaryZipLongitude: primaryZipLongitude,
      primaryReferer: isFirstRender(primaryReferer)
        ? `web-${window.location.origin}`
        : primaryReferer,
      zone: profile.zone.name,
      account: userName
    };

    return JSON.stringify(layerOn);
  }

  static markerOnReportBuilder(profile, mapLayer, marker) {
    const { properties, position } = marker;
    const { name, projectName, categoryName } = mapLayer;
    const {
      primaryZip, userName, firstName, lastName, primaryOrganization,
      primaryOrganizationType, primaryTitle, title, primaryZipLatitude,
      primaryZipLongitude, primaryReferer
    } = profile.data;
    const markerObj = {
      markerName: properties.name,
      markerLayer: name,
      projectName: projectName,
      categoryName: categoryName,
      lat: position.lat,
      lng: position.lng,
      userName: userName,
      firstName: firstName,
      lastName: lastName,
      organization: primaryOrganization,
      organizationType: primaryOrganizationType,
      title: primaryTitle,
      role: title,
      postalCode: primaryZip,
      primaryZipLatitude: primaryZipLatitude,
      primaryZipLongitude: primaryZipLongitude,
      primaryReferer: isFirstRender(primaryReferer)
        ? `web-${window.location.origin}`
        : primaryReferer,
      zone: profile.zone.name,
      account: userName
    };

    return JSON.stringify(markerObj);
  }

  static audit(token, msg) {
    const headers = { token };
    const body = { message: msg };
    const requestOptions = {
      method: 'POST',
      headers,
      body
    };

    apiFetch(API.LOGGER.AUDIT, requestOptions)
      .then(response => logToConsole('AUDIT::', msg))
      .catch(error => logToConsole('AUDIT::', error));
  }
}

export default Logger;
